/**
 * maskMemId — 排行榜等公開版位顯示會員帳號時的遮罩。
 *
 * 規則:保留前 3 碼,其餘一律以固定的 "***" 取代(不反映原長度)。
 *   963852741 → 963***
 *   GOGO1099  → GOG***
 *   戰神雷神tw → 戰神雷***
 *
 * 短 ID(長度 ≤ 3)只留首碼,否則等於完全沒遮:
 *   ccc → c***
 *   777 → 7***
 *   ab  → a***
 *   a   → a***
 *
 * 【暫時性】後端預計於下週對 memId 做同樣的遮罩處理。
 * 為了讓交接不需要動到八個站台,這裡先檢查字串是否已含 "*":
 * 一旦後端開始回傳已遮罩的值,本函式就自動讓位、原樣輸出,
 * 不會出現 96***\*\*\* 這種疊加遮罩。屆時可安全移除呼叫端。
 *
 * @param {string|number|null|undefined} memId
 * @returns {string} 遮罩後字串;空值回傳空字串(呼叫端自行決定 fallback)
 */
export const maskMemId = (memId) => {
  if (memId === null || memId === undefined) return "";

  const value = String(memId).trim();
  if (!value) return "";

  /* 後端已遮罩 → 直接沿用,避免重複遮 */
  if (value.includes("*")) return value;

  const KEEP = 3;
  const MASK = "***";

  /* 長度不足時只留首碼,避免「前 3 碼」等於整組帳號 */
  if (value.length <= KEEP) return `${value.slice(0, 1)}${MASK}`;

  return `${value.slice(0, KEEP)}${MASK}`;
};

export default maskMemId;
